(function() {
    'use strict';
    // Directives used in our admin pages

    angular.module('GorillaBoy.Admin')
    .directive('gbDomainList', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                list: '=',
                errorList: '=',
                action: '=',
                erroraction: '='
            },
            template:
            '<ul class="domain-list">' +
                '<li ng-repeat="domain in errorList" class="domain">' +
                    '<div>'+
                        '<a class="pull-right" ng-click="erroraction($index)">x</a>' +
                        '<span class="inline-error">{{domain}}</span>' +
                    '</div>' +
                '</li>'+
                '<li ng-repeat="domain in list" class="domain">' +
                    '<div>'+
                        '<a class="pull-right" ng-click="action($index)">x</a>' +
                        '<span class="ellipsis">{{domain}}</span>' +
                    '</div>' +
                '</li>'+
            '</ul>'
        };
    });
}());